module.exports = __webpack_public_path__ + "static/snigdha-4c01629b2f8ece3fa6ee8e62302ad702.jpeg";